<template>
  <v-card>
    <v-card-title>
      <span class="hidden-xs-only" v-if="!selected.length">{{ $t('pages.users.title') }}</span>
      <span class="hidden-xs-only" v-else>{{ selected.length }} {{ $tc('pages.users.selected', selected.length) }}</span>
      <v-spacer></v-spacer>
      <v-btn @click.native.stop="search = !search" icon>
        <v-icon class="primary--text">search</v-icon>
      </v-btn>
      <users-menu class="ml-2" :selected="selected"></users-menu>
    </v-card-title>
    <v-dialog width="640px" v-model="search">
      <v-card>
        <v-card-title>{{ $t('pages.users.search') }}</v-card-title>
        <v-divider></v-divider>
        <user-search-form v-model="rawDataFilter"></user-search-form>
      </v-card>
    </v-dialog>
    <user-table
      v-model="selected"
      :page="page"
      :descending="descending"
      :sortBy="sortBy"
      :dataFilter="dataFilter"
      @filterUpdated="data => onFilterUpdated(data)">
    </user-table>
  </v-card>
</template>

<script>
  import Utils from '@/utils/default'
  import UserTable from '@/components/user/Table.vue'
  import UsersMenu from '@/components/UsersMenu.vue'
  import UserSearchForm from '@/components/user/Search.vue'
  export default {
    components: {
      UserTable,
      UsersMenu,
      UserSearchForm
    },
    props: {
      page: {
        type: Number,
        default: 1
      },
      descending: {
        type: Boolean,
        default: true
      },
      sortBy: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        selected: [],
        search: false,
        rawDataFilter: Object.keys(this.$route.query)
          .filter(x => x.startsWith('q['))
          .map(x => x.replace('q[', '').replace(']', ''))
          .reduce((acc, res) => ({
            ...acc,
            [res]: this.$route.query[`q[${res}]`]
          }), {})
      }
    },
    computed: {
      dataFilter () {
        return Object.keys(this.rawDataFilter)
          .reduce((acc, x) => ({
            ...acc,
            [`q[${x}]`]: this.rawDataFilter[x]
          }), {})
      }
    },
    methods: {
      onFilterUpdated (filter) {
        this.$router.push({
          ...this.$route,
          query: Utils.dataForUrl(filter)
        })
      }
    },
    watch: {
      rawDataFilter () {
        this.search = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Users.vue